import styled from 'styled-components';
import { ThemeColours, transparentThemeColour } from '../../../styles/ThemeColours';
import { Breakpoint, ZIndex } from '../../../styles/constants';
import { ChevronUp } from '../../icons/outlined/ChevronUp';

export const ChevronIcon = styled(ChevronUp)<{
  open?: boolean;
}>`
  color: ${ThemeColours.primary500};
  transform: ${({ open }) => (open ? 'rotate(180deg)' : 'rotate(0)')};
  transition: transform 0.3s;
  width: auto;

  ${Breakpoint.MEDIUM} {
    height: 21px;
  }
`;

export const OverflowMenuContainer = styled.div<{ experiment?: boolean }>`
  background-color: ${ThemeColours.white};
  border-radius: 8px;
  box-shadow: 0px 1px 10px ${transparentThemeColour('black', 0.8)};
  flex-direction: column;
  overflow: hidden;
  position: absolute;
  top: calc(100% + 10px)
  width: 100%;
  z-index: ${ZIndex.POPUP};

  ${Breakpoint.MEDIUM} {
    top: calc(100% + 10px);
    width: auto;
  }
`;

export const OverflowMenuItem = styled.div`
  color: ${ThemeColours.mono800};
  cursor: pointer;
  padding: 12px 24px;
  transition: background-color 0.3s, color 0.3s;

  ${Breakpoint.MEDIUM} {
    padding: 12px;
  }

  &:hover {
    background-color: ${ThemeColours.mono100};
  }
`;
